export { default as useGetGeneralInfo } from "./useGetGeneralInfo";
